import axios from "@/api/axiosAuthRequired.js"

const getAuthHeaders = () => {
  let headers = {}
  let clientCredentials = window.localStorage.getItem("client_credentials")
  if (clientCredentials) {
    headers["Authorization"] = "Bearer " + clientCredentials
  }

  return headers
}

export const fetchPatchReviews = () => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/game-meta/leagueoflegends/patch-reviews",
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchSummonerSpells = () => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/game-resources/leagueoflegends/static-data/summoner-spells",
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}
export const fetchItems = () => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/game-resources/leagueoflegends/static-data/items",
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchRunes = () => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/game-resources/leagueoflegends/static-data/runes",
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchChampions = () => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/game-resources/leagueoflegends/static-data/champions",
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchServerVersion = () => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/game-resources/leagueoflegends/static-data/server-version",
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchChampionDetailsByChampionKey = key => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      `api/v2/game-resources/leagueoflegends/static-data/champions/by-key/${key}`,
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetch5v5TierList = () => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/game-meta/leagueoflegends/champions/5v5sr-tier-list",
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchChampion5v5DataByChampionId = id => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      `api/v2/game-meta/leagueoflegends/champions/${id}/5v5sr-data`,
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchGuidesByChampionId = id => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      `api/v2/game-resources/leagueoflegends/champions/${id}/guides?language=en_US`,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

// for dashboard

const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL

export const getUserLeagueInfo = async () => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: `Bearer ${clientCredentials}`,
      },
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/user/account/games/leagueoflegends`
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getUserLeagueRank = async () => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: `Bearer ${clientCredentials}`,
      },
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/user/account/games/leagueoflegends/league`
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const getUserLeagueMatches = async offset => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: `Bearer ${clientCredentials}`,
      },
    }
    let url = `${PROGUIDES_WEB_URL}api/v2/user/account/games/leagueoflegends/matches?limit=6`
    if (offset) {
      url += `&offset=${offset}`
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const getSummonerSpells = async () => {
  try {
    let url = `${PROGUIDES_WEB_URL}api/v2/game-resources/leagueoflegends/static-data/summoner-spells`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getRunes = async () => {
  try {
    let url = `${PROGUIDES_WEB_URL}api/v2/game-resources/leagueoflegends/static-data/runes`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getRuneById = async id => {
  try {
    let url = `${PROGUIDES_WEB_URL}api/v2/game-resources/leagueoflegends/static-data/runes/${id}`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const hardRefresh = async () => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: `Bearer ${clientCredentials}`,
      },
    }
    let url = `${PROGUIDES_WEB_URL}api/v2/user/account/games/leagueoflegends/hard-refresh`
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const getMatchByServerAndId = async (server, id) => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: `Bearer ${clientCredentials}`,
      },
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/game-resources/leagueoflegends/match/by-server/${server}/by-id/${id}`
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const getSingleMatchHistory = async offset => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: `Bearer ${clientCredentials}`,
      },
    }
    let url = `${PROGUIDES_WEB_URL}api/v2/user/account/games/leagueoflegends/matches?limit=1`
    if (offset) {
      url += `&offset=${offset}`
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}



// WEBPACK FOOTER //
// ./src/api/leagueoflegends.js